// extracted by mini-css-extract-plugin
export default {"productsButton":"CustomerProductsCard_productsButton__+nOrU","limitsContainer":"CustomerProductsCard_limitsContainer__OHtTu"};